<template>
  <div class="relative w-[27vw] max-w-28" :class="{ 'w-20': small }">
    <div class="relative w-[27vw] max-w-28" :class="{ 'w-20': small }">
      <div class="absolute flex justify-center items-center top-0 bottom-0 w-full">
        <img class="mt-4 w-2/6 h-2/6" :src="require('@/assets/' + icon)">
      </div>
      <Doughnut
        :data="data"
        :options="options"
        :plugins="plugins"
      />
    </div>
    <div v-if="loading">Loading...</div>
    <div v-else-if="label" class="text-2xl font-medium" :class="{ 'text-lg': small }">{{ label }}</div>
    <div v-if="name">{{ name }}</div>
  </div>
</template>

<script>
import { Doughnut } from 'vue-chartjs'
import { Chart as ChartJS, ArcElement } from 'chart.js'

ChartJS.register(ArcElement)

export default {
  name: 'MetricCircle',
  components: {
    Doughnut
  },
  props: {
    value: Number, // Value is how full the bar should be from 0..100.
    label: String, // Label is the number to be shown, including units.
    icon: String, // Path of the icon image.
    name: String, // Name is the metric is called.
    small: Boolean, // If you like it small.
  },
  data() {
    return {
      loading: !this.value ? true : false,
      data: this.updateData(),
      options: {
        responsive: true,
        maintainAspectRatio: true,
        rotation: -(300/2),
        circumference: 300,
        cutout: '85%',
        borderRadius: 100,
      },
      plugins: [],
    }
  },
  watch: {
    value() {
      this.updateData()
    },
  },
  methods: {
    updateData() {
      // Handle scores of 0.
      this.loading = (this.value === undefined || this.value === false || this.value === null || isNaN(this.value)) ? true : false
      // Handle scores greater than 100.
      const display = Math.min(this.value || 0, 100)
      this.data = {
        datasets: [{
          data: [display, 100 - display],
          backgroundColor: [
            'rgb(54, 162, 235)',
            'rgb(225, 225, 225)',
          ],
        }]
      }
      return this.data
    }
  },
}
</script>